<template>
  <div class="two-section">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TwoSection',
  props: {
    data: {
      type: Object
    }
  }
  // data: () => {
  //
  // },
};
</script>

<style scoped lang="scss">
.container {
  @media (min-width: 1000px) {
    max-height: 40vw;
  }
  @media (min-width: 1280px) {
    max-height: 33vw;
  }
  @media (min-width: 1450px) {
    max-height: 25vw;
  }
}
.two-section {
  background-color: #eff0f1;
}
.page-section {
  padding: $--pcom-spacing-large 0 $--pcom-spacing-x-large;
}
.two-section.bottom {
  background-color: $white;
}

.columns {
  margin: 0;
}

.split-section {
  background-color: $base;
  display: flex;
  filter: drop-shadow(0 0.125rem 0.25rem $grey-light);
  flex-direction: column;

  @media (min-width: 1000px) {
    flex-direction: row;
  }
}

.final-section {
  display: flex;
  flex-direction: column;

  @media (min-width: 1000px) {
    flex-direction: row;
  }
}

.first-section {
  // Mobile settings
  order: 2;
  padding: 15px 15px;

  // Larger Formats and Desktop
  @media (min-width: 1000px) {
    order: 1;
    padding: clamp(32px, 2.75vw + 23px, 76px);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

.second-section {
  // Mobile settings
  order: 1;
  min-height: 450px;
  padding: 0;

  // Larger Formats and Desktop
  @media (min-width: 1000px) {
    order: 2;
    min-height: 325px;
  }
  @media (min-width: 1500px) {
    max-height: 425px;
  }

  img {
    border-radius: 0 12px 12px 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
    overflow: clip;

    @media (max-width: 1000px) {
      border-radius: 12px 12px 0 0;
    }
  }
}

.final {
  background-color: $base;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.second {
  border-radius: 0 12px 12px 0;

  @media (max-width: 1000px) {
    border-radius: 12px 12px 0 0;
    max-height: 425px;
  }
  @media (max-width: 1200px) {
    max-height: 375px;
  }
  @media (min-width: 1200px) {
    max-height: 425px;
  }
}

.third {
  order: 1;
  img {
    border-radius: 12px;
  }

  @media (max-width: 1000px) {
    border-radius: 12px 12px 0 0;
    max-height: 425px;
  }
  @media (max-width: 1200px) {
    max-height: 375px;
  }
  @media (min-width: 1200px) {
    max-height: 425px;
  }
}

.yellow-porsche {
  order: 1;
  background: url(~@/assets/img/homepage/yellow-porsche.jpg) no-repeat
    center/100%;
  border-radius: 12px;
}

.stay-connected {
  color: $base;
  .columns {
    background-color: $primary !important;
  }
}

.contact {
  img {
    @media (min-width: 1300px) {
      order: 2;
      max-height: 425px;
    }
  }
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}
</style>
